function updateFreeShipping(cartTotal) {
  if (cartTotal === null) return;
  const shippingContainers = document.querySelectorAll('.shipping-container');
  if (!shippingContainers) return;

  shippingContainers.forEach(shippingContainer => {
    const lineProgressBar = shippingContainer.querySelector('.progress');
    const shippingLabel = shippingContainer.querySelector('.shipping-label');
    const freeShippingLabel = shippingContainer.querySelector('.free-shipping-label');
    const progressBar = shippingContainer.querySelector('[role="progressbar"]');

    if (!lineProgressBar || !shippingLabel || !freeShippingLabel || !progressBar ) {
      return;
    } 

    const remaining = window.freeShippingThreshold - cartTotal;
    const percentageBar = Math.min(Math.round((cartTotal / window.freeShippingThreshold) * 100), 100);

    lineProgressBar.style.width = percentageBar + '%';
    progressBar.setAttribute('aria-valuenow', percentageBar);

    if (remaining > 0) {
      const remainingFormatted = new Intl.NumberFormat(window.locale,{
        style: 'currency',
        currency: window.currencyCode
        }
      ).format(remaining);
      const messageAmountUpdated = window.translations.label_remaining.replace('{{ amount }}', remainingFormatted);
    
      shippingLabel.textContent = messageAmountUpdated;
      shippingLabel.classList.remove('hidden');
      freeShippingLabel.classList.add('hidden');
      progressBar.setAttribute('aria-labelledby', shippingLabel.id);

    } else {
      shippingLabel.classList.add('hidden');
      freeShippingLabel.classList.remove('hidden');
      progressBar.setAttribute('aria-labelledby', freeShippingLabel.id);
    }
  });
};

$(document).on('ajaxCart.afterCartLoad', function(evt, cart) { 
  updateFreeShipping(cart.total_price / 100);
});